import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import ExpandableMenu from '../expandable_menu/expandable_menu'
import './appBar.scss'

export default function MainAppBar (props) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position='fixed' elevation={0} className='main_appbar'>
        <Toolbar className='appbar_toolbar'>
          <ExpandableMenu scrollToRef={props.scrollToRef} />
          <Typography variant='body1' component='div' className='appbar_brand'>
            SV / SYSTEM 01
          </Typography>
          <div className='appbar_index'>PORTFOLIO 2026</div>
          <Button
            className='appbar_home'
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            HOME
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  )
}
